<template>
    <div>
        <div v-if="appLoaded">
            <div v-if="isLoggedIn" id="page">
                <Navbar/>
                <div id="main-container">
                    <div class="sidebar">
                        <Sidebar/>
                    </div>
                    <div class="page-content">
                        <router-view></router-view>
                    </div>
                </div>
            </div>
            <div v-else>
                <router-view></router-view>
            </div>
        </div>
    </div>

</template>

<script>
import Navbar from "@/components/navigation/Navbar";
import Sidebar from "@/components/navigation/Sidebar";
import {mapGetters, mapState} from "vuex";

export default {
    name: 'App',
    components: {Sidebar, Navbar},
    computed: {
        ...mapGetters(['isLoggedIn']),
        ...mapState(['appLoaded']),
    }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,300;0,400;0,600;0,700;1,300;1,400;1,600;1,700&display=swap');

body {
    font-family: 'Nunito', sans-serif !important;
}
</style>

<style scoped>
#page {
    height: 100vh;

    display: flex;
    flex-direction: column;
}

#main-container {
    flex-grow: 1;

    display: flex;
}

.sidebar {
    background: #F8F8F8;
    width: 250px;
    height: 100%;
}

.page-content {
    flex-grow: 12;
    background: #F2F2F2;
    display: flex;
    overflow-y: auto;
}
</style>